import React, { useContext } from 'react';
import { RESULTS, GRAPHICS } from './constants' // These constants where originally used in DashBoard and actions where moved here since 2023.05
import { VIEW, UPDATE, ADD_BENEFIT, OPEN, COPY, DELETE, UNLOCK, CALCULATE } from '../../assets/Constants/actionsTypes';
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import { DropDownButton, DropDownButtonItem } from '@progress/kendo-react-buttons';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../context/Auth/AuthContext';
import './scenario.css';
//* Icons
import { TiMediaStopOutline, TiInputChecked } from "react-icons/ti";

const ScenarioGrid = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    // Session context to get the current institution data
    const { user } = useContext(AuthContext)
    // Used to show the icon inside the grid
    const showCheckIcon = (props) => {
        return (
            <td className="isCompleted_check" style={{ textAlign: "center" }}>
                {
                    props.dataItem.isCalculated ? <TiInputChecked /> : <TiMediaStopOutline />
                }
            </td>
        );
    }

    // * If the model is being edited by the logged in user, an action called UNLOCK will appear. 
    // * This action releases the model so that another user can edit it. 
    const showUnlockAction = (gridProps) => {
        if (gridProps.dataItem.editLockUserCode !== null && gridProps.dataItem.editLockUserCode === user.email) {
            return (
                <DropDownButtonItem text={t('grids.unlock_btn')} value={UNLOCK} />
            );
        }
    }

    // Returns the column with the required data and the click event
    const GetScenarioCodeNameCell = (props) => {
        // Ref. :
        // [Kendo React Data Grid - Styling](https://www.telerik.com/kendo-react-ui/components/grid/styling/)
        // [Kendo React Data Grid - Custom Cells](https://www.telerik.com/kendo-react-ui/components/grid/cells/)
        return (<td onClick={()=>columnClick(props.dataItem)} className="" colSpan="1" role="gridcell" aria-colindex="3" aria-selected="false">[{props.dataItem.code}] {props.dataItem.name}</td>)
    }

    // Returns the column with the required data and the click event
    const GetModelCodeNameCell = (props) => {
        return (<td onClick={()=>columnClick(props.dataItem)} className="" colSpan="1" role="gridcell" aria-colindex="3" aria-selected="false">[{props.dataItem.modelCode}] {props.dataItem.modelName}</td>)
    }

    // Returns the column with the required data and the click event
    const GetYearCell = (props) => {
        return (<td onClick={()=>columnClick(props.dataItem)} className="scn_header_align" colSpan="1" role="gridcell" aria-colindex="3" aria-selected="false">{props.dataItem.finalYear}</td>)
    }

    // Returns the column with the required data and the click event
    const GetDescriptionCell = (props) => {
        return (<td onClick={()=>columnClick(props.dataItem)} className="scn_header_align" colSpan="1" role="gridcell" aria-colindex="3" aria-selected="false">{props.dataItem.description}</td>)
    }

    // Allows the user to navigate to the matrix control with a single click on any of the columns.
    const columnClick = (cellInfo) => {
        // Object to be sent to the parent 
        let obj = {
            value: OPEN
        }
        
        // Navigation
        props.onActionClick(obj, cellInfo);
    }

    return (
        <>
            <Grid
                style={{ height: 'calc(70vh)' }}
                data={[...props.data]}>
                {/* this is the message when there are no records */}
                <GridNoRecords>{t('grids.no_records')}</GridNoRecords>
                {/* columns of the grid */}
                <Column field="scenario" title={t('scenarios.grid_column_scenario')} cell={GetScenarioCodeNameCell}/>                
                <Column field="model" title={t('scenarios.grid_column_model')} cell={GetModelCodeNameCell} />
                <Column field="finalYear" title={t('scenarios.grid_column_finalyear')} className="scn_header_align" width="105" cell={GetYearCell}/>
                <Column field="description" title={t('scenarios.grid_column_description')} cell={GetDescriptionCell}/>
                <Column field="isCalculated" title={t('scenarios.grid_column_calc')} cell={showCheckIcon} className="scn_header_align" width="100" />
                {/* action column */}
                <Column
                    title={t('grids.action_col')}
                    width="100px"
                    field="actions"
                    cell={gridProps => (
                        <td className="text-center p-0">
                            <DropDownButton className="grid-drop-btn" text="..." onItemClick={(e) => { props.onActionClick(e.item, gridProps.dataItem); }}>
                                {/**<DropDownButtonItem text={t('grids.view_btn')} value={VIEW} />*/}
                                <DropDownButtonItem text={t('grids.open_btn')} value={OPEN} />
                                <DropDownButtonItem text={t('grids.update_btn')} value={UPDATE} />
                                {showUnlockAction(gridProps)}
                                {/** <DropDownButtonItem text={t('grids.results_btn')} value={RESULTS} /> */}
                                <DropDownButtonItem text={t('grids.charts_btn')} value={GRAPHICS} />
                                <DropDownButtonItem text={t('grids.calculate_btn')} value={CALCULATE} />
                                <DropDownButtonItem text={t('grids.addBen_btn')} value={ADD_BENEFIT} />
                                <DropDownButtonItem text={t('grids.duplicate_btn')} value={COPY} />
                                <DropDownButtonItem text={t('grids.delete_btn')} value={DELETE} />                                
                            </DropDownButton>
                        </td>
                    )}
                />
            </Grid>
        </>
    )
}

export default ScenarioGrid